import React from 'react'

const PageNotFound = () => {
  return (
    <>
      <div className="text-center text-danger my-5">
        <h1>404: Page Not Found</h1>
        <a href="/" className='btn btn-danger'>Go To Home Page</a>
      </div>
    </>
  )
}

export default PageNotFound
